export default {
  //文字数超出时，超出部分使用...
  ellipsis(value, maxlength) {
    if (!value) return ''
    if (value.length > maxlength) {
      return value.slice(0, maxlength) + '...'
    }
    return value
  },
  //日期格式化 2021-02-03
  formatDate(date) {
    return `${date.getFullYear()}-${date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)}-${date.getDate() >= 10 ? date.getDate() : '0' + date.getDate()}`;
  },

  //日期格式化 20210203
  formatDatecsrq(date) {
    return `${date.getFullYear()}${date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)}${date.getDate() >= 10 ? date.getDate() : '0' + date.getDate()}`;
  },

  //审核结果
  auditSummary(shztdm, shr, shyj, shsj) {
    if (!shztdm) {
      return '';
    }

    var h = shr;

    if (shztdm == '2' || shztdm == '3') {
      h += '审核通过；'
    } else if (shztdm == '4') {
      h += '审核不通过；'
    } else if (shztdm == '0') {
      h += '退回；'
    }
    if (shyj) {
      h += '意见：' + shyj;
    }
    if (shsj) {
      h += '；时间：' + shsj;
    }
    return h;
  },
  //审核状态
  getshztmc(value,str){
    let text = '';
    if(value == '0'){
      text = '退回';
    }else if(value == '1'){
      text = '未审核';
    }else if(value == '2'){
      text = '审核中';
    }else if(value == '3'){
      text = '审核通过';
    }else if(value == '4'){
      text = '审核不通过';
    }else{
      text = str;
    }
    return text;
  },
  //字符串转时间格式(2022-03-15 01:01:00)
  getStringDate(strDate) {
    var st = strDate;
    var a = st.split(" ");
    var b = a[0].split("-");
    var c = a[1].split(":");
    var date = new Date(b[0], b[1], b[2], c[0], c[1], c[2]);
    return date;
  },
  //检查后缀
  getistp(filename){
    if(filename != null && filename != ''){
      let ext = ['png', 'jpg', 'bmp', 'gif', 'jpeg']
      let isok = false;
      var filetype = filename.split('.').pop().toLowerCase();
      for (var l = 0; l < ext.length; l++) {
        if (filetype === ext[l]) {
          isok = true
          break;
        }
      }
      return isok
    }else{
      return false;
    }
  },
  //去掉中文
  getqdzw(value){
    var reg =/[\u4e00-\u9fa5]/g;
    var str= value;
    try{
      str= str.replace(/[ ]/g, "");//去空格
      str= str.replace(reg, "");//去除中文
      return str;
    }catch (e) {
      return value;
    }
  },
  checkrq(value) {
    const regex = /^\d{4}-\d{2}-\d{2}$/;//正则表达式校验
    if (!regex.test(value)) {
      return "您输入日期格式不正确！例如：2021-01-12";
    } else if (this.checkDate(value) == false) {
      return "您输入的日期不合法，请确认！";
    } else {
      return "ok";
    }
  },
  checkDate(value) {
    let days = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    let YMD = value.split("-");
    let y = parseInt(YMD[0], 10);
    let m = parseInt(YMD[1], 10);
    let d = parseInt(YMD[2], 10);
    //判断月份是否合法
    if (m > 12 || m < 1) {
      return false;
    }
    //判断是否是闰年
    if((y % 4 == 0 && y % 100 != 0)||(y % 400 == 0)) {
      days[2] = 29;
    }
    //判断当月天数是否合法
    if (d > days[m]) {
      return false;
    }
  },
  rexFilterHtml(data)
  {
    let dats =JSON.stringify(data);
    if(dats.length>20000)
    {
      return data;
    }
    let result = dats.replace(/&([^&;]+);/g, function(matchStr, b) {
      let entity = {
        quot: '"',
        lt: '<',
        gt: '>',
        apos: "'",
        amp: '&',
        ldquo: '“',
        rdquo: '”'
      };
      let r = entity[b];
      return typeof r === 'string' ? r : matchStr;
    });
    return JSON.parse(result)
  }
}



// WEBPACK FOOTER //
// ./src/utils/commonutils.js